var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('input-wrapper',{attrs:{"sm":"10","md":"6"}},[_c('pdf-uploader',{attrs:{"box-probs":_vm.boxProbs,"label":"CV","filename":"cv","tag":_vm.cv_tag,"legacy-marker":"cv"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }